import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import coinSrc from 'images/profile_coin.png'
import arrowRightSrc from 'images/icon/arrow_right_4e4e4e-25x48.png'

import pfchange from 'images/pfchange.png'
import appInfoContainer from 'auth/appInfoContainer'

export default function MypageProfile({
  userInfo,
  groupslist,
  friendNum,
  userImg,
  totalUserGroup,
}) {
  const history = useHistory()

  return (
    <ProfileContainer>
      <ProfileBody>
        <ProfileCol1
          onClick={() => {
            history.push(`/mypage/profile/change/${userInfo.id}`)
          }}
        >
          <ProfileImageWrapper>
            <ProfileImage src={appInfoContainer.imagePath + '/user_profile_img/' + userImg} />
          </ProfileImageWrapper>

          <ProfileEditImageWrapper>
            <ProfileEditImage src={pfchange} />
          </ProfileEditImageWrapper>
        </ProfileCol1>

        <ProfileCol2>
          <ProfileNameArea>{userInfo.name}</ProfileNameArea>

          <ProfileCountArea>
            <ProfileCountWrapper
              onClick={() => {
                history.push('/friend')
              }}
            >
              <ProfileCountKey>친구</ProfileCountKey>
              <ProfileCountValue>{new Intl.NumberFormat().format(friendNum)}</ProfileCountValue>
            </ProfileCountWrapper>

            <ProfileCountAreaDivider />

            <ProfileCountWrapper
              onClick={() => {
                history.push('/mypage/point/history')
              }}
            >
              <ProfileCountKey>포인트</ProfileCountKey>
              <ProfileCountValue>
                {new Intl.NumberFormat().format(userInfo.exp_point)}
              </ProfileCountValue>
            </ProfileCountWrapper>
          </ProfileCountArea>
        </ProfileCol2>
      </ProfileBody>

      <PointBox
        onClick={() => {
          history.push('/mypage/point/history')
        }}
      >
        <PointBoxLeft>
          <PointImgWrapper>
            <PointImg src={coinSrc} />
          </PointImgWrapper>

          <PointTitle>포인트 사용 / 내역</PointTitle>
        </PointBoxLeft>

        <PointBoxRight>
          <PointRightArrowWrapper>
            <PointRightArrowIcon src={arrowRightSrc} />
          </PointRightArrowWrapper>
        </PointBoxRight>
      </PointBox>
    </ProfileContainer>
  )
}

const ProfileContainer = styled.div`
  padding: 0 calc(100vw * (17 / 375));
  margin-top: calc(100vw * (25 / 375));
  margin-bottom: calc(100vw * (23 / 375));
`

const ProfileBody = styled.div`
  margin-bottom: calc(100vw * (19 / 375));
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ProfileCol1 = styled.div`
  position: relative;
`

const ProfileImageWrapper = styled.div`
  width: calc(100vw * (72 / 375));
  height: calc(100vw * (72 / 375));
  border-radius: 50%;
  border: 1px solid #d9d9d9;
  overflow: hidden;
`

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ProfileEditImageWrapper = styled.div`
  width: calc(100vw * (26 / 375));
  height: calc(100vw * (27 / 375));
  position: absolute;
  bottom: calc(100vw * (2 / 375));
  right: calc(100vw * (-5 / 375));
`

const ProfileEditImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ProfileCol2 = styled.div`
  margin-left: calc(100vw * (18 / 375));
`

const ProfileNameArea = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #000;
`

const ProfileCountArea = styled.div`
  margin-top: calc(100vw * (11 / 375));
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ProfileCountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ProfileCountKey = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #7f7f7f;
`

const ProfileCountValue = styled.div`
  margin-left: calc(100vw * (3 / 375));
  font-weight: 700;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #4e4e4e;
`

const ProfileCountAreaDivider = styled.div`
  width: 1px;
  height: calc(100vw * (12 / 375));
  background-color: #c4c4c4;
  margin: 0 calc(100vw * (14 / 375));
`

const PointBox = styled.div`
  background-color: #fff6de;
  border-radius: calc(100vw * (11 / 375));
  padding: calc(100vw * (15 / 375)) calc(100vw * (20 / 375)) calc(100vw * (15 / 375))
    calc(100vw * (14 / 375));
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const PointBoxLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const PointImgWrapper = styled.div`
  width: calc(100vw * (19 / 375));
  height: calc(100vw * (19 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
`

const PointImg = styled.img`
  width: 100%;
  height: 100%;
`

const PointTitle = styled.div`
  font-weight: 600;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #4e4e4e;
  margin-left: calc(100vw * (6 / 375));
`

const PointBoxRight = styled.div``

const PointRightArrowWrapper = styled.div`
  width: calc(100vw * (7 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
`

const PointRightArrowIcon = styled.img`
  width: 100%;
  height: 100%;
`
